export const BASE_URL = `${process.env.REACT_APP_API_BASE_URL}/v1`;

/**
 * Same gateway, different version prefix. The member meeting routes the panel
 * borrows (join resolution) live under /v2 — the version is the first path
 * segment, not part of the host.
 */
export const BASE_URL_V2 = `${process.env.REACT_APP_API_BASE_URL}/v2`;

export const REVENUECAT_APP_ID = process.env.REACT_APP_REVENUECAT_APP_ID;

export const revenueCatCustomerUrl = (revenueCatId: string): string | undefined => {
  if (!REVENUECAT_APP_ID) return undefined;
  return `https://app.revenuecat.com/projects/${REVENUECAT_APP_ID}/customers/${revenueCatId}?tab=overview`;
};
